import { useAllSizeGroupings } from "http-hooks/sizeGrouping/useSizeGrouping";
import DeleteSizeGrouping from "components/sizeGrouping/DeleteSizeGrouping";
import { useState } from "react";
import useModalStore from "store/modals";
import InputSearch from "components/ui/InputSearch";
import MasterPage, {
  FilterRow,
  FilterCell,
  ClearFiltersButton,
  AddButton,
  EditAction,
  DeleteAction,
} from "components/ui/MasterPage";

const initialFilter = {
  name: "",
  page: 1,
  limit: 10,
};

const columns = [
  { key: "name", header: "Group Name" },
  { key: "size_uom", header: "UOM" },
  { key: "actions", header: "Actions", isActions: true },
];

export default function SizeGroupingMaster() {
  const [filter, setFilter] = useState(initialFilter);
  const { openModal } = useModalStore();

  const openSetModal = (id) => openModal("sizeGrouping", id);

  const handleSearch = (searchTerm) => {
    setFilter((prev) => ({ ...prev, name: searchTerm, page: 1 }));
  };

  const clearFilters = () => {
    setFilter(initialFilter);
  };

  const {
    isLoading,
    data: { data: allGroups, page: currentPage, totalPages } = {},
  } = useAllSizeGroupings(filter);

  return (
    <MasterPage
      title="Size Group Master"
      description="Manage size groups used for grouping item details in pricelists"
      headerActions={
        <AddButton onClick={() => openSetModal()}>Add Size Group</AddButton>
      }
      filters={
        <FilterRow>
          <FilterCell>
            <InputSearch
              onSearch={handleSearch}
              label="Group Name"
              placeholder="Search group name"
            />
          </FilterCell>
          <ClearFiltersButton onClick={clearFilters} />
        </FilterRow>
      }
      columns={columns}
      data={allGroups}
      isLoading={isLoading}
      rowKey="id"
      deleteComponent={DeleteSizeGrouping}
      renderActions={(item, setDeleteItemId) => (
        <>
          <EditAction onClick={() => openSetModal(item.id)} title="Edit Size Group" />
          <DeleteAction onClick={() => setDeleteItemId(item.id)} title="Delete Size Group" />
        </>
      )}
      pagination={{
        currentPage,
        totalPages,
        onPageChange: (page) => setFilter((prev) => ({ ...prev, page })),
      }}
    />
  );
}
